import React from 'react';
import ProjectVideoLoop from '../../../../components/project/project-video-loop';
import ProjectFullBanner from '../../../../components/project/project-full-banner';
import ProjectMarketingTiles from '../../../../components/project/project-marketing-tiles';
import ProjectQuote from '../../../../components/project/project-quote';

const HeinekenCaseStudy = ({ acf }) => {
  return (
    <React.Fragment>
      <ProjectVideoLoop
        videoId={acf.video_loop_id}
        muted={'true'}
        background={'true'}
        blurb={acf.video_loop_blurb}
        wrapperPadding={'0 0 10vw 0'}
        autoplay={true}
      />
      <ProjectFullBanner
        image={acf.full_banner_image}
        blurb={acf.full_banner_blurb}
        wrapperPadding={'0'}
      />
      <ProjectMarketingTiles
        images={acf.marketing_tiles}
        blurb={acf.marketing_tiles_blurb}
        wrapperPadding={'10vw 0 3vw 0'}
      />
      <ProjectQuote
        quote={acf.quote}
        name={acf.quote_name}
        title={acf.quote_title}
      />
    </React.Fragment>
  );
};

export default HeinekenCaseStudy;



// WEBPACK FOOTER //
// ./src/templates/project/case-studies/heineken/index.js